import { Type } from '@angular/core';
import { CustomFilterTypeModel } from './custom-filter-type.model';
import { DiscoverListFilterModel } from '../../../api/mentions/model/discover-list-filter.model';
import { AbstractFilterTypeComponent } from './abstract-filter-type.component';
import { ChipModel } from '../../Forms/models/chip.model';
import { IncludeExcludeEnum } from '../enums/include-exclude.enum';
import { AuditableModel } from '../../Misc/models/auditable.model';
import { DiscoverListTypeEnum } from '../../../api/mentions/enum/discover-list-type.enum';

export class DiscoverListsFilterModel extends CustomFilterTypeModel<DiscoverListFilterModel> {

    value: DiscoverListFilterModel;
    currentValue: DiscoverListFilterModel;

    chips: ChipModel[] = [];
    currentChips: ChipModel[] = [];

    source: AuditableModel[] = [];

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        section?: string,
        showIncludeExclude?: boolean
    ) {
        super(id, label, component, section, showIncludeExclude);
    }

    hasValue(): boolean {
        return this.value?.discoverListType
            && (this.value?.discoverList?.include?.length > 0 || this.value?.discoverList?.exclude?.length > 0);
    }

    hasCurrentValue(): boolean {
        return this.currentValue?.discoverListType
            && (this.currentValue?.discoverList?.include?.length > 0 || this.currentValue?.discoverList?.exclude?.length > 0);
    }

    setValue(value: DiscoverListFilterModel): void{
        this.value = value;
        this.chips = [];
        let listId: number;
        if(value?.discoverList?.exclude?.length > 0) {
            this.includeExclude = IncludeExcludeEnum.exclude;
            listId = value.discoverList.exclude[0];
        } else if(value?.discoverList?.include?.length > 0) {
            this.includeExclude = IncludeExcludeEnum.include;
            listId = value.discoverList.include[0];
        }
        if (value) {
            this.addChip(value.discoverListType, listId);
        }
        this.setCurrentValue(this.value);
    }

    getValue(): DiscoverListFilterModel {
        return this.value;
    }

    setCurrentValue(value: DiscoverListFilterModel) {
        this.currentValue = value;
        this.currentChips = [];
        let listId: number;
        if(value?.discoverList?.exclude?.length > 0) {
            this.currentIncludeExclude = IncludeExcludeEnum.exclude;
            listId = value.discoverList.exclude[0];
        } else if(value?.discoverList?.include?.length > 0) {
            this.currentIncludeExclude = IncludeExcludeEnum.include;
            listId = value.discoverList.include[0];
        }
        if (value) {
            this.addCurrentChip(value.discoverListType, listId);
        }
    }

    getCurrentValue(): DiscoverListFilterModel {
        return this.currentValue;
    }

    createChip(listType: DiscoverListTypeEnum, listId: number, isExclude: boolean = false): ChipModel {
        const list = this.source.find(item => item.id === listId);

        return list ? {
            label: `Discover.listSource.chipLabel.${listType}`,
            labelArgs: {list: list.name},
            suffix: isExclude ? 'Common.forms.chips.exclude.suffix' : ''
        } : null;
    }

    addChip(listType: DiscoverListTypeEnum, listId: number) {
        const chip = this.createChip(listType, listId, this.includeExclude ===  IncludeExcludeEnum.exclude);
        if(chip) {
            this.chips.push(chip);
        }
    }

    addCurrentChip(listType: DiscoverListTypeEnum, listId: number) {
        const chip = this.createChip(listType, listId, this.currentIncludeExclude ===  IncludeExcludeEnum.exclude);
        if(chip) {
            this.currentChips.push(chip);
        }
    }

    removeChip(chip?: ChipModel): void {
        const newValue = new DiscoverListFilterModel();
        newValue.useEmploymentOutletId = false;
        this.setValue(newValue);
        this.setIncludeExclude(IncludeExcludeEnum.include);
        this.source = [];
    }

    removeCurrentChip(chip?: ChipModel): void {
        const newValue = new DiscoverListFilterModel();
        newValue.useEmploymentOutletId = false;
        this.setCurrentValue(newValue);
        this.setCurrentIncludeExclude(IncludeExcludeEnum.include);
        this.source = [];
    }

    cancelChanges(): void {
        this.setCurrentValue(this.value);
    }

    clear(): void {
        this.removeChip();
    }

}
